(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("sbInlineEdit", ["$timeout", function ($timeout) {
            return {
                restrict: "E",
                scope: {
                    id: "@",
                    value: "=?",
                    placeholder: "@",
                    emptyText: "@",
                    onSave: "=?",
                    onCancel: "=?",
                    maxlength: "=?",
                    inputClass: "=?",
                    object: "=?",
                    readonly: "=?"
                },
                transclude: true,
                templateUrl: "app/templates/sbInlineEditTemplate.html",
                //compile: function (elem, attr) {
                link: function (scope, element) {
                    var inputElement = element.find(".inline-input");
                    scope.clearOnSave = false;
                    if (scope.value === undefined)
                        scope.clearOnSave = true;
                    scope.initialValue = scope.value;
                    scope.isEditing = false;
                    scope.blur = function () {
                        scope.blurTimeout = $timeout(function () {
                            scope.stopEdit(true);
                        }, 500);
                    };
                    scope.edit = function () {
                        if (scope.readonly)
                            return;
                        $timeout.cancel(scope.blurTimeout);
                        if (scope.isEditing) {
                            inputElement.focus();
                            return;
                        }
                        scope.isEditing = true;
                        scope.initialValue = scope.value;
                        $timeout(function () {
                            inputElement.focus();
                            inputElement[0].setSelectionRange(0, inputElement[0].value.length);
                        });
                    };
                    scope.stopEdit = function (save) {
                        if (scope.readonly)
                            return;
                        if (!scope.isEditing)
                            return;
                        if (scope.savePromise !== undefined && scope.savePromise.$$state.pending !== undefined && scope.savePromise.$$state.pending.length > 0)
                            return;
                        if (scope.value === undefined || scope.value.trim() === "" || scope.initialValue === scope.value)
                            save = false;
                        clearErrors();
                        if (save !== false) {
                            $timeout.cancel(scope.blurTimeout);
                            if (scope.onSave !== undefined) {
                                scope.savePromise = scope.onSave(scope.value, scope.object);
                                scope.savePromise.then(function () {
                                    scope.isEditing = false;
                                    if (scope.clearOnSave)
                                        delete scope.value;
                                    else
                                        scope.initialValue = scope.value;
                                    scope.isSaving = false;
                                    inputElement.blur();
                                }, function (error) {
                                    showErrors(error);
                                    if (error.exitEditMode === true) {
                                        scope.isEditing = false;
                                        scope.value = scope.initialValue;
                                        inputElement.blur();
                                    }
                                    else {
                                        inputElement.focus();
                                    }
                                });
                            }
                            else {
                                scope.isEditing = false;
                                if (scope.clearOnSave)
                                    delete scope.value;
                                else
                                    scope.initialValue = scope.value;
                                inputElement.blur();
                            }
                        }
                        else {
                            scope.isEditing = false;
                            scope.value = scope.initialValue;
                            inputElement.blur();
                        }
                    };
                    scope.checkKeys = function (event) {
                        if (event.keyCode === 13) { //Enter Key
                            scope.stopEdit(true);
                        }
                        else if (event.keyCode === 27) { //Esc key
                            scope.stopEdit(false);
                        }
                    };
                    function showErrors(error) {
                        scope.$parent.vm[scope.id].$error = error;
                    }
                    function clearErrors() {
                        scope.$parent.vm[scope.id].$error = {};
                    }
                    element.on("$destroy", function () {
                        $timeout.cancel(scope.blurTimeout);
                    });
                    scope.$parent.vm[scope.id] = {
                        $error: {},
                        $stopEdit: scope.stopEdit,
                        $edit: scope.edit,
                        $isEditing: function () {
                            return scope.isEditing;
                        },
                        $value: scope.value
                    };
                }
            };
        }]);
}());
